/** @jsxRuntime classic */
/** @jsx jsx */

import { jsx } from '@emotion/react';
import { Margin as MarginZDS } from '@zapier/design-system';

type Props = {
  marginTop?: number;
  marginRight?: number;
  marginBottom?: number;
  marginLeft?: number;
  children: React.ReactNode;
};

export function Margin(props: Props) {
  return (
    <MarginZDS
      margin={`
      ${props.marginTop || 0}px 
      ${props.marginRight || 0}px 
      ${props.marginBottom || 0}px 
      ${props.marginLeft || 0}px
      `}
    >
      {props.children}
    </MarginZDS>
  );
}
